import { useRunEstimatedAnnualConsumptionAnalysis } from "@/entities/annualConsumption"
import { logger } from "@/lib/logger"
import { formatEffyPrefilledElectricityConsumption } from "../utils/formatEffyPrefilledElectricityConsumption"

type RunEffyConsumptionAnalysisProps = {
    meterPointId: string
    firstName: string
    lastName: string
}

export function useRunEffyConsumptionAnalysis() {
    const consumptionAnalysis = useRunEstimatedAnnualConsumptionAnalysis()

    async function handleRunEffyConsumptionAnalysis(props: RunEffyConsumptionAnalysisProps) {
        try {
            const data = await consumptionAnalysis.mutateAsync({
                meterPointId: props.meterPointId,
                firstName: props.firstName,
                lastName: props.lastName,
            })

            const consumption = formatEffyPrefilledElectricityConsumption(data.consumption)

            return {
                consumption,
                token: !consumption && data.unavailableReason ? data.token : null,
            }
        } catch (error) {
            logger.error({
                error,
                meta: {
                    feature: "effy",
                    source: "runEstimatedAnnualConsumptionAnalysis",
                },
            })

            return { consumption: null, token: null }
        }
    }

    return [handleRunEffyConsumptionAnalysis] as const
}
